<template lang="pug">
  CommonLoadBox(:loaded="loaded")
    template(slot='skeleton')
      TaskSkeleton
    template(slot='module')
      .task-module-container(v-if="taskData")
        .task-module-item(:class="{'new-module': newModule, 'new-style': newStyle}")
          .header
            .title(v-if="newStyle")
              img.title-img(v-if="taskData.titleIcon" :src="taskData.titleIcon" alt="")
              span(v-else) {{ taskData.mainTitle }}
            .title(v-else) {{ moduleTitle }}
          bounty-coupon(
            :double-information="getDoubleInformation(taskData)"
            :new-module="newModule"
            :data="taskData.taskCouponList"
            :preparing="preparing"
            :moduleKey="taskData.key"
            @bounty="$emit('bounty')"
            @refreshTasks="refreshTasks"
          )
</template>

<script>
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getVersion } from '@/utils/systemCode';
import eventBus from '@/const/eventBus.js';
import CommonLoadBox from '@/components/common-load-box';
import { taskGroupListAdapter } from '../common/helper';
import BountyCoupon from './bounty-coupon';
import TaskSkeleton from '../skeleton-cpns/task-skeleton';

export default {
  name: 'BountySurprise',
  components: {
    BountyCoupon,
    CommonLoadBox,
    TaskSkeleton,
  },
  props: {
    newModule: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      taskData: null,
      preparing: true,
      loaded: false,
      prepareTimer: null,
    };
  },
  inject: ['newTaskScene', 'taskScene'],
  computed: {
    newStyle() {
      return this.newTaskScene();
    },
    moduleTitle() {
      return '惊喜任务';
    },
  },
  created() {
    // 先检查全局缓存（防止组件渲染晚了）
    if (window.__TASK_DATA_CACHE__) {
      this.handleTaskData(window.__TASK_DATA_CACHE__);
    }

    // 监听任务数据加载事件
    eventBus.$on('taskDataLoaded', this.handleTaskData);
    // 监听数据加载失败事件
    eventBus.$on('taskDataLoadError', this.handleTaskDataError);
  },
  async mounted() {
    this.prepareTimer = setTimeout(() => {
      if (this.preparing) {
        this.preparing = false;
      }
    }, 2000);
  },
  destroyed() {
    if (this.prepareTimer) {
      clearTimeout(this.prepareTimer);
      this.prepareTimer = null;
    }

    eventBus.$off('taskDataLoaded', this.handleTaskData);
  },
  methods: {
    refreshTasks() {
      eventBus.$emit('refreshTaskList');
    },
    getDoubleInformation(items) {
      return {
        bannerAdvertisementUnitId: items.bannerAdvertisementUnitId || '',
        bannerTaskRelationCouponInfo: items.bannerTaskRelationCouponInfo || {},
      };
    },
    handleTaskDataError(error) {
      // eslint-disable-next-line no-console
      console.error('[BountySurprise] bounty.vue 请求失败:', error);
      this.taskData = null;
      this.loaded = true;
      this.preparing = false;
    },
    async handleTaskData(allTaskData) {
      try {
        const surpriseTaskData = allTaskData.filter(
          (item) => item.moduleKey === 'welfare_surprise_tasks',
        );
        if (!surpriseTaskData || !surpriseTaskData.length) {
          this.taskData = null;
          this.loaded = true;
          this.preparing = false;
          return;
        }

        const surpriseTask = surpriseTaskData[0];

        const adaptedDataList = await taskGroupListAdapter(
          { list: surpriseTaskData, isRefresh: true },
          () => { this.refreshTasks(); },
        );


        this.taskData = adaptedDataList && adaptedDataList.length > 0 ? adaptedDataList[0] : null;

        const oldData = surpriseTask.taskCouponList.map((task) => ({
          mainTitle: surpriseTask.mainTitle,
          ...task,
        }));

        (oldData || []).forEach((task) => {
          UBT.moduleExpose({
            pageId: 'Welfare',
            categoryId: 'platform',
            moduleId: 'platform_Welfare_superStarTask',
            contentId: 'platform_Welfare_superStarTask',
            exposureTimes: 1,
            businessInfo: {
              clk_url: (task.btnLink && task.btnLink.app) || task.titleBarUrl || '',
              btn_name: task.btnName || '',
              task_status: task.taskStatus,
              adsource: this.$route.query.adsource || '',
              taskname: task.taskName || task.title || '',
              taskId: task.taskCode || '',
            },
          });
        });


        const version = await getVersion();
        if (version >= '6.63.0') {
          const videoList = oldData.filter((x) => x.taskActivityType === 8);
          if (videoList.length > 0) {
            if (videoList[0].advertCode) {
              const json = JSON.stringify({
                classMap: 'hellobike/marketing/rewardVideo',
                method: 'preloadRewardVideo',
                params: JSON.stringify({
                  adUnitId: videoList[0].advertCode,
                }),
                callbackId: 'preloadRewardVideoCallbackId',
              });
              if (env.isAndroid) {
                window.AppFunctions.callNative(json);
              } else if (env.isIOS) {
                window.webkit.messageHandlers.callNative.postMessage(json);
              }
            }
          }
        }

        this.loaded = true;
        this.preparing = false;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[BountySurprise] handleTaskData error:', error);
        this.taskData = null;
        this.loaded = true;
        this.preparing = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.task-module-container {
  .page-title {
    height: 0.27rem;
    margin: 0.1rem 0 0.04rem 0.09rem;
  }

  .task-module-item {
    width: 100%;
    padding: 0.12rem 0.16rem 0.12rem;
    background-color: white;
    border-radius: 0.12rem;
    margin-bottom: 0.08rem;

    &:last-child {
      margin-bottom: 0;
    }

    .header {
      display: flex;
      // flex-direction: column;
      align-items: flex-start;
      flex-direction: row;
      position: relative;

      .title {
        margin-bottom: 0.12rem;
        display: flex;
        font-size: 0.16rem;
        font-weight: 500;
        color: #242729;
      }

      .sub-title {
        font-size: 0.12rem;
        position: relative;
        top: 0.04rem;
        left: 0.02rem;
      }
    }

    &.new-style {
      padding: 0.14rem 0.12rem 0.12rem;

      .title {
        margin-bottom: 0.14rem;
      }

      .title-img {
        width: auto;
        height: 0.22rem;
      }

      .flex {
        margin-bottom: 0.19rem;
        display: flex;

        .title-img {
          width: 1.31rem;
          height: 0.27rem;
        }

        .task-desc {
          margin-left: 0.08rem;
          width: 1.12rem;
          height: 0.27rem;
          line-height: 0.32rem;
          color: #5a6066;
          font-family: 'PingFang SC', sans-serif;
          font-size: 0.12rem;
        }
      }
    }

    &.new-module {
      padding: 0.16rem;

      .header {
        .title {
          margin-bottom: 0.16rem;
          color: #333;
          font-size: 0.16rem;
        }
      }
    }
  }
}
</style>
